(function ($) {
  "use strict";

  const CheckoutPreview = {
    allowNextClick: false,

    init() {
      this.$modal = $("[data-bb-checkout-preview]");

      if (!this.$modal.length) {
        return;
      }

      this.dataset = this.$modal[0].dataset;
      this.$contactPhone = this.$modal.find("[data-preview-contact-phone]");
      this.contactPhoneInput = this.$contactPhone.find("[data-checkout-contact-phone]")[0] || null;

      window.addEventListener("click", (event) => this.intercept(event), true);

      this.$modal.on("click", "[data-preview-confirm]", () => this.confirm());

      if (this.contactPhoneInput) {
        this.contactPhoneInput.addEventListener("input", () => this.contactPhoneInput.setCustomValidity(""));
        this.$modal.on("shown.bs.modal", () => this.focusEmptyContactPhone());
        this.$modal.on("hidden.bs.modal", () => {
          this.contactPhoneInput.required = false;
          this.contactPhoneInput.setCustomValidity("");
        });
      }
    },

    intercept(event) {
      const button = event.target instanceof Element ? event.target.closest(".payment-checkout-btn") : null;

      if (!button || !button.closest("form.checkout-form") || !document.body.contains(this.$modal[0])) {
        return;
      }

      if (this.allowNextClick) {
        this.allowNextClick = false;

        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (button.disabled) {
        return;
      }

      const form = button.form || button.closest("form");

      if (!form || !this.isReceivingChosen()) {
        return;
      }

      const visibleInvalid = Array.from(form.querySelectorAll("input:invalid, select:invalid, textarea:invalid")).find(
        (element) => element.offsetParent !== null && !element.disabled,
      );

      if (visibleInvalid) {
        visibleInvalid.reportValidity();

        return;
      }

      const $form = $(form);

      if ($form.valid && !$form.valid()) {
        return;
      }

      this.lastButton = button;
      this.render();
      this.$modal.modal("show");
    },

    confirm() {
      if (!this.isContactPhoneValid()) {
        return;
      }

      const button =
        this.lastButton && document.body.contains(this.lastButton)
          ? this.lastButton
          : document.querySelector("form.checkout-form .payment-checkout-btn");

      this.$modal.modal("hide");

      if (!button || button.disabled) {
        return;
      }

      this.allowNextClick = true;
      button.click();
    },

    isPickup() {
      const $checked = $("input.shipping_method_input:checked");

      return $checked.length > 0 && $checked.filter((_, element) => $(element).data("is-pickup") == 1).length === $checked.length;
    },

    selectedAddressId() {
      return String($("#address_id").val() || "");
    },

    usesContactPhone() {
      return Boolean(this.contactPhoneInput) && (this.isPickup() || this.selectedAddressId() === "pin" || !this.savedAddressPhone());
    },

    savedAddressPhone() {
      const addressId = this.selectedAddressId();

      return String(
        $(".list-available-address .address-item-wrapper")
          .filter((_, element) => String($(element).attr("data-id")) === addressId)
          .find(".address-item")
          .first()
          .attr("data-phone") || "",
      ).trim();
    },

    isContactPhoneValid() {
      if (!this.usesContactPhone()) {
        return true;
      }

      const input = this.contactPhoneInput;

      input.setCustomValidity(input.value.trim() === "" ? this.dataset.contactPhoneRequiredMessage || "" : "");

      return input.reportValidity();
    },

    fitContactPhonePadding() {
      const flag = this.contactPhoneInput.closest(".iti--separate-dial-code")?.querySelector(".iti__selected-flag");

      if (!flag) {
        return;
      }

      const modal = this.$modal[0];
      const { display, visibility } = modal.style;
      const isClosed = window.getComputedStyle(modal).display === "none";

      if (isClosed) {
        modal.style.visibility = "hidden";
        modal.style.display = "block";
      }

      const width = flag.offsetWidth;

      if (isClosed) {
        modal.style.display = display;
        modal.style.visibility = visibility;
      }

      if (width) {
        this.contactPhoneInput.style.paddingLeft = `${width + 6}px`;
      }
    },

    focusEmptyContactPhone() {
      if (this.usesContactPhone() && this.contactPhoneInput.value.trim() === "") {
        this.contactPhoneInput.focus();
      }
    },

    isReceivingChosen() {
      if (this.isPickup()) {
        const $pickupInput = $('input[name="pickup_location_id"]');

        if ($pickupInput.length && !$pickupInput.val() && $("#checkout-pickup-modal").length) {
          document.dispatchEvent(new CustomEvent("checkout:open-pickup-picker"));

          return false;
        }

        return true;
      }

      if (!$("[data-checkout-delivery-card]").length) {
        return true;
      }

      const $addressId = $("#address_id");
      let isChosen;

      if ($addressId.length) {
        const value = String($addressId.val() || "");
        const $item = $(".list-available-address .address-item-wrapper")
          .filter((_, element) => String($(element).attr("data-id")) === value)
          .find(".address-item")
          .first();

        isChosen = value !== "" && value !== "new" && $item.length > 0 && Boolean($item.attr("data-latitude")) && Boolean($item.attr("data-longitude"));
      } else {
        isChosen = Boolean($('[data-guest-location][name="address[latitude]"]').val()) && Boolean($("#address_address").val());
      }

      if (!isChosen) {
        document.dispatchEvent(new CustomEvent("checkout:open-location-picker"));
      }

      return isChosen;
    },

    render() {
      this.renderItems();
      this.renderAmount();
      this.renderReceiving();
    },

    icon(name) {
      return this.$modal.find(`[data-preview-icon="${name}"]`).html() || "";
    },

    itemDetails($row) {
      const priceLabel = this.dataset.optionPriceLabel || "";
      const details = $row
        .find(".col > p.mb-0 small:not(.text-muted)")
        .map((_, element) => $(element).text().replace(/\s+/g, " ").trim())
        .get();

      $row.find(".col > .small > span:first-child").each((_, element) => {
        const text = $(element).text().replace(/\s+/g, " ").trim();

        if (text && !(priceLabel && text.startsWith(`${priceLabel}:`))) {
          details.push(text);
        }
      });

      return details.filter(Boolean).join(" · ");
    },

    renderItems() {
      const $target = this.$modal.find("[data-preview-items]").empty();
      let count = 0;

      $(".checkout-products-marketplace .product_group").each((_, group) => {
        const $group = $(group);
        const storeName = $group.find(".vendor-information-section .font-weight-bold").first().text().trim();
        const $section = $('<div class="checkout-preview-store"></div>');

        if (storeName) {
          $section.append(
            $('<div class="checkout-preview-store__name"></div>').append(
              $('<span class="checkout-preview-store__icon"></span>').html(this.icon("store")),
              $("<span></span>").text(storeName),
            ),
          );
        }

        $group.find(".cart-item").each((__, row) => {
          const $row = $(row);
          const $name = $row.find(".col > p.mb-0").first().clone();

          $name.find(".stock-status-label").remove();

          const name = $name.text().replace(/\s+/g, " ").trim();
          const image = $row.find("img.item-thumb").first().attr("src");
          const quantity = $row.find(".checkout-quantity").first().text().trim();
          const price = $row.find(".col-auto p").first().text().trim();
          const details = this.itemDetails($row);
          const $thumb = $('<span class="checkout-preview-item__thumb"></span>');

          if (image) {
            $thumb.append(
              $("<img>")
                .attr({ src: image, alt: name })
                .on("error", (event) => $(event.currentTarget).remove()),
            );
          }

          if (quantity) {
            $thumb.append($('<span class="checkout-preview-item__quantity"></span>').text(quantity));
          }

          const $body = $('<span class="checkout-preview-item__body"></span>').append(
            $('<span class="checkout-preview-item__name"></span>').text(name),
          );

          if (details) {
            $body.append($('<span class="checkout-preview-item__details"></span>').text(details));
          }

          $section.append(
            $('<div class="checkout-preview-item"></div>').append(
              $thumb,
              $body,
              $('<span class="checkout-preview-item__price"></span>').text(price),
            ),
          );

          count += parseInt(quantity, 10) || 1;
        });

        $target.append($section);
      });

      this.$modal.find("[data-preview-items-count]").text(count ? count : "").prop("hidden", !count);
    },

    renderAmount() {
      const $target = this.$modal.find("[data-preview-amount]").empty();

      $(".cart-item-wrapper .amount__wrapper .row")
        .filter((_, row) => !$(row).hasClass("d-none"))
        .each((_, row) => {
          const $columns = $(row).children();
          const label = $columns.first().text().replace(/\s+/g, " ").trim().replace(/:$/, "");
          const value = $columns.last().text().replace(/\s+/g, " ").trim();

          if (label) {
            $target.append(
              $('<div class="checkout-preview-amount"></div>')
                .toggleClass("is-negative", value.startsWith("-"))
                .append($("<span></span>").text(label), $("<strong></strong>").text(value)),
            );
          }
        });
    },

    renderReceiving() {
      const $title = this.$modal.find("[data-preview-receiving-title]");
      const $target = this.$modal.find("[data-preview-receiving]").empty();
      const isPickup = this.isPickup();
      let name;
      let address;

      if (isPickup) {
        const $card = $("[data-checkout-pickup-card]");

        $title.text(this.dataset.pickupLabel);
        name = $card.find("[data-pickup-card-name]").text().trim();
        address = $card.find("[data-pickup-card-address]").text().trim();
      } else {
        const $card = $("[data-checkout-delivery-card]");

        $title.text(this.dataset.deliveryLabel);

        if ($card.length) {
          name = $card.find("[data-delivery-card-name]").text().trim() || $("#address_name").val();
          address = $card.find("[data-delivery-card-text]").text().trim();
        } else {
          name = $("#address_name").val();
          address = $("#address_address").val();
        }
      }

      const usesContactPhone = this.usesContactPhone();
      const phone = usesContactPhone ? "" : this.receivingPhone();
      const $body = $('<span class="checkout-preview-receiving__body"></span>');

      this.$contactPhone.prop("hidden", !usesContactPhone);

      if (this.contactPhoneInput) {
        this.contactPhoneInput.required = usesContactPhone;
        this.contactPhoneInput.setCustomValidity("");
      }

      if (usesContactPhone) {
        this.fitContactPhonePadding();
      }

      if (name) {
        $body.append($('<span class="checkout-preview-receiving__name"></span>').text(name));
      }

      if (address) {
        $body.append($('<span class="checkout-preview-receiving__address"></span>').text(address));
      }

      if (phone) {
        $body.append(
          $('<span class="checkout-preview-receiving__phone"></span>').append(
            $('<span class="checkout-preview-receiving__phone-icon"></span>').html(this.icon("phone")),
            $("<span></span>").text(`${this.dataset.contactPhoneLabel}:`),
            $("<strong></strong>").text(phone),
          ),
        );
      }

      $target.append(
        $('<div class="checkout-preview-receiving"></div>').append(
          $('<span class="checkout-preview-receiving__icon"></span>').html(this.icon(isPickup ? "pickup" : "delivery")),
          $body,
        ),
      );
    },

    receivingPhone() {
      if (this.contactPhoneInput) {
        return this.savedAddressPhone();
      }

      return $('[name="address[phone]"]').val() || $("#address_phone").val();
    },
  };

  $(() => CheckoutPreview.init());
})(jQuery);
